export const USERNAME_REGEX = /^[a-z0-9\-_.~]{2,64}$/i;
export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,64}$/g;

export const PASSWORD_RULES_VALIDATION =
  "minlength: 8; maxlength: 64; required: lower; required: upper; required: digit; required: special;";

export const YEAR_FIRST_VEHICLE_PRODUCED = 1886;
const MAX_FUTURE_YEARS = 5;
export const MAX_FUTURE_YEAR =
  new Date(Date.now()).getUTCFullYear() + MAX_FUTURE_YEARS;

export const DB_MAX_INT = 2147483647;
